export default {
  getRamais: state => state.ramais,
  getTroncosDisponveis: state => state.troncosDisponiveis,
  getRotasDisponiveis: state => state.rotasDisponiveis,
  getRamalSelecionado: state => state.ramalSelecionado,
  getGrupos: state => state.grupos,
  buscarRamalByNumero: state => numero => state.ramais.find(ramal => ramal.numero === numero),
  buscarRamalByNumeroDoBanco: state => state.ramalSelecionado,
  getGruposDeRotas: state => state.gruposDeRotas,
}
